import * as React from 'react';
import { ISvgAtomProps } from './Atoms.interfaces';

const ProductAttributes: React.FC<ISvgAtomProps> = ({ width = 16, height = 16, fill = '#e9ecef' }) => {
  return (
    <svg x={0} y={0} width={width} height={height} viewBox={`0 0 ${width} ${height}`}>
      <circle cx={width / 2} cy={height / 2} r={width / 2} fill={fill} />
    </svg>
  );
};

export default ProductAttributes;
